import React, { useState } from "react";
import { Button, Checkbox, Col, Row, Space, Typography } from "antd";
import { getAllGenre } from "../../api/Get";
import { postSerieGenre } from "../../api/Post";

const { Title, Text } = Typography;

const GenreSerie = (props) => {
  const { serieGenres, idSerie, onSuccess } = props;

  const [mockData, setMockData] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const constructList = React.useCallback(async () => {
    const res = await getAllGenre();
    const allGenres = res.genres.map((g) => g.name);

    const tempTargetKeys = [];
    const tempMockData = [];

    for (let i = 0; i < allGenres.length; i++) {
      const genre = allGenres[i];
      const data = {
        label: genre,
        value: genre,
      };

      if (serieGenres.includes(genre)) tempTargetKeys.push(data.value);
      tempMockData.push(data);
    }

    setTargetKeys(tempTargetKeys);
    setMockData(tempMockData.sort((a, b) => a.label.localeCompare(b.label)));
  }, [serieGenres]);

  const saveGenres = async () => {
    setIsLoading(true);
    const res = await postSerieGenre(idSerie, { genres: targetKeys });
    if (res.error) setErrMsg(res.error);
    else onSuccess();
    setIsLoading(false);
  };

  React.useEffect(() => {
    constructList();
  }, [constructList]);

  const handleChange = (newTargetKeys) => {
    setTargetKeys(newTargetKeys);
  };

  return (
    <Space direction="vertical" style={{ marginTop: 40, marginBottom: 100 }}>
      <Row justify="center" align="middle">
        <Col flex="auto">
          <Title level={4}>Modifier les genres de la série</Title>
        </Col>
        <Col flex="none">
          <Button type="primary" onClick={saveGenres} loading={isLoading}>
            Enregistrer
          </Button>
        </Col>
      </Row>
      <Text type="danger">{errMsg}</Text>
      <Checkbox.Group value={targetKeys} onChange={handleChange}>
        <Row>
          {mockData.map((d) => (
            <Col span={8}>
              <Checkbox value={d.value}>{d.label}</Checkbox>
            </Col>
          ))}
        </Row>
      </Checkbox.Group>
    </Space>
  );
};

export default GenreSerie;
